import { trigger } from "redial";
import { history } from "../../client/history";
import { setPageName, setPageLoading } from "../../state/modules/page/actions";
import clientSideRedirect from "../../state/modules/search/clientSideRedirect";
import { PAGE_NOT_FOUND } from "../../state/modules/page/constants";
import getIsNewPage from "./getIsNewPage";
import matchRoutes from "../../routes/matchRoutes";
import { clearCategoryError } from "../../state/modules/category";

let shortCircuit = false;
let lastKnownGoodLocation;

const setupRouteChangeListener = store => {
  lastKnownGoodLocation = history.location;
  history.listen(location => {
    if (shortCircuit) {
      return;
    }

    const { pathname, search: query } = location;

    const activeRoute = matchRoutes({ pathname });

    if (activeRoute.key === PAGE_NOT_FOUND) {
      clientSideRedirect({ redirectUrl: `${pathname}${query}` });
    } else if (activeRoute.key) {
      const { dispatch, getState } = store;
      const { category, search, page } = getState();
      const catId = category.details?.id;
      const searchTerm = search?.searchTerm;

      const isNewPage = getIsNewPage({ query, catId, searchTerm, page });

      const locals = {
        store,
        location,
        dispatch,
        isNewPage
      };

      activeRoute.props.component.load().then(loadedComponent => {
        if (isNewPage) {
          dispatch(clearCategoryError());
          dispatch(setPageName(activeRoute.key));
          dispatch(setPageLoading(true));
        }

        trigger("fetch", loadedComponent.default, locals).then(() => {
          const { error } = getState();
          if (error) {
            shortCircuit = true;
            history.replace(lastKnownGoodLocation);
          }
          shortCircuit = false;
          lastKnownGoodLocation = history.location;
        });
      });
    }
  });
};

export default setupRouteChangeListener;
